import { LitElement, html, css } from 'lit';
import '../../Time/Timestamp';
import '../../ReadMark/SingleMark/SingleMark.js';
import '../../ReadMark/BlueReadMark/BlueReadMark.js';
import '../../ReadMark/DoubleMark/DoubleMark.js';
import '../../ReadMark/ClockMark/ClockMark.js';
import { processTextWithMentions } from '../../../../lib/taguser.js';
import './link-preview.css';
import LinkPlaceHolder from '../../../../assets/images/link.svg';
import '../../EmojiReactions/EmojiReactions.js';
import '../../Popup/ConfirmationPopup/DeleteConfirmationPopup/DeletePopup.js';
import'../../ForwardMessage/ForwardUi.js'
import '../../../../components/ChatUIComponent/ReactionContainer.js'

class LinkPreview extends LitElement {
  static properties = {
    url: { type: String },
    isRead: { type: Boolean },
    isDelivered: { type: String },
    time: { type: String },
    textColor: { type: String },
    message: { type: String },
    backgroundColor: { type: String },
    isSelf: { type: Boolean },
    mentionedUsers: { type: Array },
    preview: { type: Object },
    isMessageInfo: { type: Boolean },
    isShowFooter: { type: Boolean },
    showReactionButton: { type: Boolean },
    showEmojiReactions: { type: Boolean },
    messageId: { type: String },
    reactions: { type: Object },
    showConfirmationPopup: { type: Boolean },
    selectedEmojiToRemove: { type: Object },
    showAllReactionsPopup: {type: Boolean},
    userMetaData: {type: Object},
    messageType: { type: Number },
    timeColor: { type: String },

    showReactionOnHover: {type: Boolean}
  };

  constructor() {
    super();
    this.url = '';
    this.isRead = false;
    this.isDelivered = '';
    this.time = '';
    this.textColor = '';
    this.message = '';
    this.backgroundColor = '';
    this.isSelf = false;
    this.mentionedUsers = [];
    this.preview = null;
    this.isMessageInfo = false;
    this.isShowFooter = true;
    this.isLoading = false;
    this.showReactionButton = false;
    this.showEmojiReactions = false;
    this.reactions = {};
    this.showAllReactionsPopup = false;
    this.showReactionOnHover = true;
  }

  static styles = css`
    :host {
      display: block;
    }
    .emoji-slider {
      position: absolute;
    }

    emoji-reactions {
      position: absolute;
      top: 15px;
      z-index: 99;
      left: 0;
    }

    .reaction-button {
      position: absolute;
      top: 50%;
      right: -25px;
      transform: translateY(-50%);
      cursor: pointer;
      z-index: 100;
    }

    .message-container {
      position: relative;
    }

    .link-container {
      border-radius: 12px;
      max-width: 500px;
      width: fit-content;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
    .link-footer {
      border: 1px solid #e1e1e1;
      border-radius: 12px;
      width: 100%;
      background: #fff;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
    .link-container-info {
      border: 1px solid #e1e1e1;
      border-radius: 12px;
      width: 80%;
      background: #fff;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
    .link-preview {
    background-color:var(--bg-primary-light);
      border-radius: 12px;
      max-width: 240px;
    }
    .link-preview-footer {
      border: 1px solid #e1e1e1;
      border-radius: 12px;
      width: 100%;
      display: flex;
      flex-direction: row;
      background: #fff;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
    .preview-image {
      width: 100%;
      height: 200px;
      background: #f5f5f5;
    }

    .preview-image img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .preview-content {
      padding: 12px;
    }

    .preview-title {
      margin: 0 0 8px;
      font-size: 1.1rem;
      color: var(--text-secondary-color);
    }

    .preview-description {
      margin: 0 0 12px;
      color: #666;
      font-size: 0.9rem;
      line-height: 1.4;
    }

    /* Updated footer styles */
    .preview-footer {
      display: flex;
      max-width: 600px;
      flex-direction: column;
      gap: 4px;
    }
    .preview-message {
      padding-top: 10px;
    }

    .message-footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 4px;
      margin-top: 2px;
    }

    .message-footer > div {
      display: flex;
      align-items: center;
    }

    .link-preview-loading {
      padding: 12px;
      text-align: center;
      color: #666;
    }
    @keyframes shimmer {
      0% {
        background-position: -1000px 0;
      }
      100% {
        background-position: 1000px 0;
      }
    }

      .remaining-count {
      background-color: var(--bg-primary-light);
      font-size: 14px;
      display: flex;
      justify-content: center;
      color: var(--text-primary-color);
      width: 25px;
      cursor: pointer;
    }

        .all-reactions-popup-overlay {
     position: fixed;
     height: 100vh;
      width: 100vw;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--overlay-color);
      z-index: 99;
    }

    .all-reactions-popup {
      background: var(--bg-primary-color);
      border: 1px solid var(--border-primary-color);
      border-radius: 8px;
      padding: 12px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      z-index: 1000;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      min-width: 150px;
      color: var(--text-primary-color);
    }

    .all-reactions-heading {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
    }

    .all-reactions-heading h3 {
       margin: 0
    }

    .all-reactions-heading button {
      cursor: pointer;
    }

    .all-reactions-list {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 32px;
    }

    .reactions-display {
      position: absolute;
      bottom: -10px;
      right: 10px;
      display: grid;
      grid-template-columns: repeat(3, auto);
      gap: 0;
      margin-top: 4px;
      background-color: transparent;
    }
        reaction-container {
      display: block;
       min-height: 150px;
       max-height: fit-content;
       min-width: 300px;
       max-width: 400px;
       position: absolute;
       z-index: 100;
    }

    .reaction-item {
      display: flex;
      align-items: center;
      gap: 2px;
      border-radius: 12px;
      font-size: 20px;
      background: var(--bg-secondary-color);
      cursor: pointer;
    }
    .shimmer-loading {
      background: linear-gradient(to right, rgba(214, 222, 249, 0.47) 0%, rgba(212, 211, 240, 0.2) 50%, rgba(189, 188, 239, 0.45) 100%);
      background-size: 1000px 100%;
      animation: shimmer 2s infinite linear;
    }
  `;

  calculateEmojiPosition() {
    return calculateEmojiPosition(this);
  }

  handleMouseEnter() {
    if(showReactionOnHover) {
    this.showReactionButton = true;
    }
  }

  handleMouseLeave(e) {
    const messageContainer = this.renderRoot.querySelector('.message-container');
    const emojiReactions = this.renderRoot.querySelector('emoji-reactions');
    const reactionButton = this.renderRoot.querySelector('.reaction-button');

    const isEmojiSliderOpen = this.showEmojiReactions;

    const isMovingToMessage = messageContainer?.contains(e.relatedTarget);
    const isMovingToEmoji = emojiReactions && emojiReactions?.contains(e.relatedTarget);
    const isMovingToReactionButton = reactionButton && reactionButton?.contains(e.relatedTarget);

    if (!isMovingToMessage && !isMovingToEmoji && !isMovingToReactionButton) {
      this.showReactionButton = false;
      
      if (!isEmojiSliderOpen) {
        this.showEmojiReactions = false;
      }
    }
  }

  handleOutsideClick = (e) => {
    const emojiReactions = this.renderRoot.querySelector('emoji-reactions');
    const messageContainer = this.renderRoot.querySelector('.message-container');
    const reactionContainer = this.renderRoot.querySelector('reaction-container');
    
    const path = e.composedPath();
    
    if ((this.showEmojiReactions &&
      !path.includes(emojiReactions) &&
      !path.includes(messageContainer)) ||
      (this.showConfirmationPopup &&
      !path.includes(reactionContainer) &&
      !path.includes(messageContainer))
    ) {
      this.showEmojiReactions = false;
      this.showConfirmationPopup = false;
      document.removeEventListener('click', this.handleOutsideClick);
    }
  }
  toggleEmojiReactions() {
    this.showConfirmationPopup = false;

    this.showEmojiReactions = !this.showEmojiReactions;
    
    if (this.showEmojiReactions) {
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick);
      }, 100);
    }
  }

  handleReactionRemove(reaction) {
    this.showEmojiReactions = false;

    this.showConfirmationPopup = true;
    this.selectedEmojiToRemove = reaction;
     setTimeout(() => {
      document.addEventListener('click', this.handleOutsideClick)
    }, 100)
  }


  async willUpdate(changedProperties) {
    if (changedProperties.has('url')) {
      await this.fetchMetadata();
    }
  }
  isValidUrl(url) {
    try {
      if (typeof url !== 'string' || !url.trim()) {
        return false;
      }
      const parsedUrl = new URL(url);
      return (parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:') && parsedUrl.hostname.length > 0 && /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(parsedUrl.hostname);
    } catch (error) {
      return false;
    }
  }
  getAbsoluteUrl(relativeUrl, baseUrl) {
    if (!relativeUrl) return '';

    if (this.isValidUrl(relativeUrl)) {
      return relativeUrl;
    }

    try {
      const urlObj = new URL(baseUrl);

      if (relativeUrl.startsWith('//')) {
        return `${urlObj.protocol}${relativeUrl}`;
      } else if (relativeUrl.startsWith('/')) {
        return `${urlObj.origin}${relativeUrl}`;
      } else {
        return new URL(relativeUrl, urlObj.origin).toString();
      }
    } catch (error) {
      console.error('Error creating absolute URL:', error);
      return relativeUrl;
    }
  }

  async fetchMetadata() {
    this.isLoading = true;
    try {
      const response = await this.fetchWithFallbackProxies(this.url);
      const html = await response.text();
      this.preview = this.extractMetadata(html);

      if (!this.preview.title && !this.preview.description) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        this.preview.title = this.preview.title || doc.querySelector('title')?.textContent || new URL(this.url).hostname;
        this.preview.description = this.preview.description || doc.querySelector('p')?.textContent?.slice(0, 150) || this.url;
        if (!this.preview.image) {
          const firstImage = doc.querySelector('img');
          if (firstImage) {
            const imgSrc = firstImage.getAttribute('src');
            this.preview.image = this.getAbsoluteUrl(imgSrc, this.url);
          }
        }
      }
    } catch (error) {
      console.error('Error fetching link preview:', error);
      this.preview = null;
    } finally {
      this.isLoading = false;
    }
  }

  async fetchWithFallbackProxies(url) {
    const proxies = ['https://api.allorigins.win/raw?url='];
    const timeout = 5000; // 5 seconds timeout
    let lastError;

    for (const proxy of proxies) {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), timeout);

        const response = await fetch(`${proxy}${encodeURIComponent(url)}`, {
          signal: controller.signal,
        });

        clearTimeout(timeoutId);

        if (response.ok) {
          return response;
        }
      } catch (error) {
        lastError = error;
        this.preview = {};
      }
    }

    throw lastError || new Error('All proxies failed');
  }

  extractMetadata(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const getMetaContent = selectors => {
      for (const selector of selectors) {
        const meta = doc.querySelector(selector);
        if (meta && meta.getAttribute('content')) {
          return meta.getAttribute('content');
        }
      }
      return '';
    };

    const title = getMetaContent(['meta[property="og:title"]', 'meta[name="twitter:title"]']) || doc.querySelector('title')?.textContent || '';

    const description = getMetaContent(['meta[property="og:description"]', 'meta[name="twitter:description"]', 'meta[name="description"]']) || '';

    const image = getMetaContent(['meta[property="og:image"]', 'meta[name="twitter:image"]', 'meta[property="og:image:url"]']);

    const absoluteImage = this.getAbsoluteUrl(image, this.url);

    return { title, description, image: absoluteImage };
  }

  handleMentionClick = user => {
    this.dispatchEvent(
      new CustomEvent('tagUserClick', {
        detail: { userId: user?.userId, userName: user?.userName },
        bubbles: true,
        composed: true,
      }),
    );
  };

  handleEmojiClick(emoji) {
    const currentUserId = this.userMetaData?.userId;
    const usersForEmoji = this.reactions[emoji.id] || [];
    const hasReaction = usersForEmoji.includes(currentUserId);
  
    let existingReactionEmojiId = null;
  
    for (const [emojiId, userIds] of Object.entries(this.reactions)) {
      if (userIds.includes(currentUserId)) {
        existingReactionEmojiId = emojiId;
        break;
      }
    }
  
    if (existingReactionEmojiId && existingReactionEmojiId !== emoji.id) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: existingReactionEmojiId,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  
    if (hasReaction) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: emoji.id,
          },
          bubbles: true,
          composed: true,
        }),
      );
    } else {
      this.dispatchEvent(
        new CustomEvent('reaction-added', {
          detail: {
            messageId: this.messageId,
            emojiId: emoji.id,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  
    this.showEmojiReactions = false;
    document.removeEventListener('click', this.handleOutsideClick);
  }
  handleConfirmRemove() {
    if (this.selectedEmojiToRemove) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: this.selectedEmojiToRemove.emojiId,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
    this.closeConfirmationPopup();
  }

  closeConfirmationPopup() {
    this.showConfirmationPopup = false;
    this.selectedEmojiToRemove = null;
  }

  toggleAllReactionsPopup() {
    this.showAllReactionsPopup = !this.showAllReactionsPopup;
  }

  render() {
    const emojiList = document.createElement('emoji-reactions').emojis;
    const allReactions = Object.keys(this.reactions)
      .map(reaction => {
        const matchingEmoji = emojiList.find(emoji => emoji.id === reaction);
        return {
          emojiId: reaction,
          messageId: this.reactions[reaction],
          src: matchingEmoji?.src,
        };
      })
      .filter(reaction => Array.isArray(reaction.messageId) && reaction.messageId.length > 0); 
    
    const visibleReactions = allReactions.slice(0, 2);
    const remainingCount = allReactions.length > 2 ? allReactions.length - 2 : 0;
    return html`
      <div
        @mouseover="${() => this.handleMouseEnter()}"
        @mouseout="${e => this.handleMouseLeave(e)}"
        class="message-container ${this.isMessageInfo ? 'link-container-info' : !this.isShowFooter ? (this.preview ? 'link-footer' : null) : 'link-container'}"
        style="background-color:  ${this.isShowFooter ? this.backgroundColor : null}; color: ${this.isShowFooter ? this.textColor : null}; padding: 10px;"
      >
        ${this.messageType === 1
          ? html`
            <forward-ui></forward-ui>
            `
          : null}
        ${!this.isSelf && this.showReactionButton
          ? html`
        <div class="reaction-button" @click="${() => this.toggleEmojiReactions()}"  ">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--text-primary-color)">
            <path d="M612-516q25 0 42.5-17.5T672-576q0-25-17.5-42.5T612-636q-25 0-42.5 17.5T552-576q0 25 17.5 42.5T612-516Zm-264 0q25 0 42.5-17.5T408-576q0-25-17.5-42.5T348-636q-25 0-42.5 17.5T288-576q0 25 17.5 42.5T348-516Zm132 228q60 0 110.5-31t79.5-84H290q29 53 79.5 84T480-288Zm.28 192Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30ZM480-480Zm0 312q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Z"/>
          </svg>
        </div>
      `
          : ''}
        ${this.showConfirmationPopup
          ? html` <reaction-container .messageId=${this.messageId} .userMetaData=${this.userMetaData} .reactions=${allReactions}></reaction-container> `
          : ''}
        ${this.showEmojiReactions
          ? html`
              <emoji-reactions .isOpen="${this.showEmojiReactions}" .onEmojiSelect="${emoji => this.handleEmojiClick(emoji)}" .selectedEmojis="${this.reactions}"></emoji-reactions>
            `
          : ''}

        <div class="reactions-display">
          ${visibleReactions?.map(
            reaction => html`
              <span class="reaction-item" @click="${() => this.handleReactionRemove(reaction)}"> ${reaction.src ? html`<span>${reaction.src}</span>` : ''} </span>
            `,
          )}
         ${remainingCount > 0
            ? html`
                <span @click="${() => this.handleReactionRemove(visibleReactions[0])}" class="reaction-item remaining-count" @click="${this.toggleAllReactionsPopup}"> +${remainingCount} </span>
                ${this.showAllReactionsPopup
                  ? html`
                      <div class="all-reactions-popup-overlay">
                      <div class="all-reactions-popup">
                      <div class="all-reactions-heading">
                      <h3>Reactions:</h3>
                      <button style="border: none; background: transparent; outline: none; font-size: 20px;" @click="${this.toggleAllReactionsPopup}">x</button>
                      </div>
                        <div class="all-reactions-list">
                          ${allReactions.map(
                            reaction => html`
                              <div class="reaction-list-item" @click="${() => this.handleReactionRemove(reaction)}">${reaction.src ? html`<span>${reaction.src}</span>` : ''}</div>
                            `,
                          )}
                        </div>
                        </div>
                      </div>
                    `
                  : ''}
              `
            : ''}
        </div>

        ${this.isLoading
          ? html`
              <div  class="${!this.isShowFooter ? 'link-preview-footer' : 'link-preview'} shimmer-image shimmer-loading" style="display: flex; border-radius: 8px;">
                <div style="width: 80px; height: 80px; min-width: 80px;">
                  <img src="${LinkPlaceHolder}" style="width: 100%; height: 100%; object-fit: cover;" />
                </div>
                <div class="preview-content" style="padding: 12px; display: flex; flex-direction: column; justify-content: center; width: 100%; word-break : break-word;">
                  <div style="color: ${this.textColor};">${this.url}</div>
                </div>
              </div>
            `
          : this.preview
            ? html`
                <div class="${!this.isShowFooter ? 'link-preview-footer' : 'link-preview'}" style="display: flex; border-radius: 8px;  ;">
                  ${this.preview.image
                    ? html`
                        <div class="preview-image" style="width: 80px; height: 80px; min-width: 80px; position: relative;">
                          <img src="${this.preview.image}" alt="${this.preview.title}" @error="${this.handleImageError}" style="width: 100%; height: 100%; object-fit: cover;" />
                          ${this.preview.isVideo
                            ? html`<div
                                style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); background: rgba(0,0,0,0.5); border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center;"
                              >
                                <span style="color: white; font-size: 12px;">▶</span>
                              </div>`
                            : null}
                        </div>
                      `
                    : null}
                  <div class="preview-content" style="padding: 12px; display: flex; flex-direction: column; justify-content: center;">
                    <h3
                      class="preview-title"
                      style="overflow: hidden; margin: 0 0 4px; font-size: 1rem; font-weight: 600; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;  ; text-overflow: ellipsis; max-height: 2.4em; line-height: 1.2;"
                    >
                      ${this.preview.description || this.preview.title || 'Untitled'}
                    </h3>
                    <p class="preview-url" style="margin: 0; font-size: 0.8rem;">${this.preview.domain || new URL(this.url).hostname}</p>
                  </div>
                </div>
              `
            : null}
        ${this.isShowFooter
          ? html`
              <div class="preview-footer">
                <span class="preview-message"> ${processTextWithMentions(this.message, this.mentionedUsers, this.handleMentionClick, this.isSelf)} </span>
                <div class="message-footer">
                  <timestamp-element time="${this.time || new Date().toISOString()}" color="${this.timeColor}"></timestamp-element>
                  ${this.isSelf
                    ? this.isRead
                      ? html`<blue-read-mark></blue-read-mark>`
                      : this.isDelivered === 'true'
                        ? html`<double-mark></double-mark>`
                        : this.isDelivered === 'pending'
                          ? html`<clock-mark></clock-mark>`
                          : html`<single-mark></single-mark>`
                    : ''}
                </div>
              </div>
            `
          : null}
      </div>
    `;
  }

  handleImageError(e) {
    e.target.style.display = 'none';
  }
}

customElements.define('link-preview', LinkPreview);
